import React from 'react';
import PropTypes from 'prop-types';
import { ErrorPaymentsIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import {
  ErrorContentStyled as ErrorContent,
  TitleStyled as Title,
  BodyStyled as Body,
  ButtonStyled as Button,
  CancelButtonStyled as CancelButton,
} from './styles/PanelContentStyled';

const RetryError = ({ retry, close }) => {
  return (
    <ErrorContent>
      <ErrorPaymentsIcon />
      <Body>
        <Title>Ha ocurrido un error</Title>
        No se ha podido completar tu solicitud, vuelve a intentarlo
      </Body>
      <Button onClick={retry}>Reintentar</Button>
      <CancelButton variant="text" disableRipple onClick={close}>
        Cancelar
      </CancelButton>
    </ErrorContent>
  );
};

RetryError.propTypes = {
  retry: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default RetryError;
